import { APPLICATION } from '../constants/application'

const isEntitlementAcsDff = (entitlement) =>
  entitlement && entitlement.application === APPLICATION.ACSDFF

export default isEntitlementAcsDff
